import * as React from 'react';
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import { getAllProjectConfigurations } from "../../api/projectconfig"
import { useEffect, useState } from 'react';
import PrintApplication from '../../PrintApplication/page';
function ConfirmRegistration({ isTermsAccepted, setIsTermsAccepted }) {
    const [termsAndConditions, setTermsAndConditions] = useState("");

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchTermsAndConditions = async () => {
            try {
                const response = await getAllProjectConfigurations();
                console.log("Terms and condition response:", response.data);
                const terms = response.data.length > 0 ? response.data[0].termsAndConditions : "No terms and conditions available.";
                setTermsAndConditions(terms);
            } catch (error) {
                console.error("Error fetching terms and conditions", error);
            }
        };
        fetchTermsAndConditions();
    }, []);

    const renderStyledTerms = (text) => {
        const wordsToHighlight = ["Terms of Service", "Privacy Policy"];
        let parts = text.split(new RegExp(`(${wordsToHighlight.join("|")})`, "g"));
        return parts.map((part, index) => {
            if (wordsToHighlight.includes(part)) {
                return <span key={index} style={{ color: "#6e48aa", fontWeight: "600" }}>{part}</span>;
            }
            return part;
        });
    };
    const handleCheckboxChange = (event) => {
        console.log("Checkbox checked:", event.target.checked);
        setIsTermsAccepted(event.target.checked);
    };
    return (
        <>
            <Container fluid>
                <Row className='mt-4'>
                    <Col>
                        <Card>
                            <div style={{ textAlign: "center" }}>
                                <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                    className='mb-3  mt-2'> Confirm Registration</Form.Label>
                            </div>
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col>
                                            <Row className="mb-2">
                                                <Col>
                                                    <div className="mb-3" style={{ textAlign: "center" }}>
                                                        <Form.Check type="checkbox" id="check-api-checkbox" >
                                                            <Form.Check.Input type="checkbox" checked={isTermsAccepted}
                                                                onChange={handleCheckboxChange} />
                                                            <Form.Check.Label>{renderStyledTerms(termsAndConditions)}</Form.Check.Label>
                                                        </Form.Check>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                            
                                {/* <Row className="mt-2">
                                        <PrintApplication applications={applications} />
                                    </Row> */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};
export default ConfirmRegistration;